export default function Footer() {
  return (
    <footer style={{ background: 'linear-gradient(135deg, #3D1C2E 0%, #5C2B42 50%, #3D1C2E 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/79c9aafb3c7891dd76e8052ad6a6dd8f.jpeg"
                alt="Ayfer Çetin Güzellik Salonu"
                className="h-12 w-auto object-contain rounded-lg"
              />
            </div>
            <p className="font-serif text-white/90 text-lg font-bold mb-1">Ayfer Çetin</p>
            <p className="text-[#D4AF37] text-xs uppercase tracking-widest mb-4">Güzellik Salonu</p>
            <p className="text-white/60 text-xs leading-relaxed mb-5">
              Kişiye özel analiz ve profesyonel uygulama ile doğal güzelliğinizi ön plana çıkarıyoruz. 
              10 yılı aşkın deneyimimizle yanınızdayız.
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/ayfercetinguzellik/', label: 'Instagram' },
                { icon: 'ri-facebook-line', href: 'https://www.facebook.com/ayfercetinguzelliksalonu', label: 'Facebook' },
                { icon: 'ri-tiktok-line', href: '#', label: 'TikTok' },
                { icon: 'ri-youtube-line', href: '#', label: 'YouTube' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target={s.href !== '#' ? '_blank' : undefined}
                  rel="nofollow noreferrer"
                  title={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 cursor-pointer transition-all duration-300"
                >
                  <i className={`${s.icon} text-white/70 text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-5">Hızlı Linkler</h4>
            <ul className="space-y-2.5">
              {['Anasayfa', 'Hizmetler', 'Teknoloji', 'Sonuçlar', 'Yorumlar', 'İletişim'].map((link) => (
                <li key={link}>
                  <a href={`#${link.toLowerCase()}`} className="text-white/65 text-sm hover:text-[#D4AF37] transition-colors flex items-center gap-2 group">
                    <i className="ri-arrow-right-s-line text-[#D4AF37]/40 group-hover:text-[#D4AF37] transition-colors"></i>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-5">Hizmetlerimiz</h4>
            <ul className="space-y-2.5">
              {['EMS Slim', 'ARC Cilt Yenileme', 'Lazer Epilasyon', 'Kalıcı Makyaj', 'Mezoterapi', 'G5 İncelme'].map((svc) => (
                <li key={svc}>
                  <span className="text-white/65 text-sm flex items-center gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[#D4AF37]/40 text-xs"></i>
                    {svc}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Working Hours & Contact */}
          <div>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-5">Çalışma Saatleri</h4>
            <ul className="space-y-2 mb-6">
              {[
                { day: 'Pazartesi - Cuma', hours: '09:00 - 19:00' },
                { day: 'Cumartesi', hours: '09:00 - 17:00' },
                { day: 'Pazar', hours: 'Kapalı' },
              ].map((item) => (
                <li key={item.day} className="flex justify-between items-center text-xs border-b border-white/10 pb-2">
                  <span className="text-white/65">{item.day}</span>
                  <span className={`font-medium ${item.hours === 'Kapalı' ? 'text-red-400' : 'text-[#D4AF37]'}`}>{item.hours}</span>
                </li>
              ))}
            </ul>
            <div className="space-y-2">
              <a href="tel:02222347234" className="flex items-center gap-2 text-white/65 text-xs hover:text-white transition-colors">
                <i className="ri-phone-line text-[#D4AF37]"></i>
                0222 234 7 234
              </a>
              <a
                href="https://wa.me/905412190629"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-2 text-white/65 text-xs hover:text-[#25D366] transition-colors"
              >
                <i className="ri-whatsapp-line text-[#25D366]"></i>
                0541 219 06 29
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Hacı+Alibey+Mahallesi+Sakarya+1+Caddesi+Gürdal+Abacı+Plaza+No+50+Eskisehir+Turkey"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-start gap-2 text-white/65 text-xs hover:text-[#D4AF37] transition-colors"
              >
                <i className="ri-map-pin-2-line text-[#D4AF37] mt-0.5 flex-shrink-0"></i>
                <span className="leading-relaxed">
                  Hacı Alibey Mah. Sakarya 1. Cad.<br />
                  Gürdal Abacı Plaza No:50 Kat:3/8<br />
                  Eskişehir
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © 2024 Ayfer Çetin Güzellik Salonu. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors">Gizlilik Politikası</a>
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors">KVKK</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
